// Override Settings
bcSfSearchSettings = {
  search: {
    // suggestionMode: 'test',
    // suggestionPosition: 'left'
    enableSearch: true,
    enableSuggestion: true,
  },
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function (suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
        params['q'] = this.getSearchTerm();
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        var enableFuzzy = this.getSettingValue('search.enableFuzzy');
        if (enableFuzzy) params.fuzzy = !enableFuzzy;
        if (params['q'].length > 4) params.fuzzy = enableFuzzy;
    
    return params;
};

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  
  var self = this;
  var result = '';
  // Buid Header
  result += this.buildSuggestionHeader(itemInfo['label'], 'product');
  // Build Did you mean
  var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
  if (dym != '') {
      result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
  }
  // Build content
  if (Object.keys(itemData).length > 0) {
      // var count = 0;   
      var k;
      var itemDataLength = itemData.length; 
      for (k = 0; k < itemDataLength; k++) {
        // if (count < itemInfo['number']) {
        var product = itemData[k];
        // Get product attributes
        var productTitle = product.title.split(product.vendor + ':').pop();
        productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
        var productUrl = this.buildProductItemUrl(product, false);
        var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
        var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
        // Get custom class / attribute
        var searchSuggestionClass = this.class.searchSuggestion;
        var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
        result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" data-label="' + this.escape(product['id']) + '" data-value="' + this.escape(product['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
        result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
        // Build Left column
        if (this.getSettingValue('search.showSuggestionProductImage')) {
            result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
        }
        // Build Right column
        result += '<div class="' + searchSuggestionClass + '-right">';
        result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>'
        if (this.getSettingValue('search.showSuggestionProductSku')) {
            result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
        }
        if (this.getSettingValue('search.showSuggestionProductVendor')) {
            result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
        }
        result += this.buildSuggestionProductPrice(product);
        result += '</div>'; // End Right column
        result += '</a>'; // End a
        result += '</li>'; // End li
        // count++;
        // } else break;
      }
  }

  return result;
};
